/* pipes.modules.ts */
import { NgModule, ModuleWithProviders } from '@angular/core';

import { ACTransPipe } from './actrans.pipe';
import { CBTransPipe } from './cbtrans.pipe';
import { IntPipe } from './int.pipe';
import { JoinPipe } from './join.pipe';
import { MessageTransPipe } from './messagetrans.pipe';
import { TelephonePipe } from './telephone.pipe';
import { NfPipe } from './nf.pipe';
import { NfiPipe } from './nfi.pipe';
import { FilterPipe } from './ngx-filter.pipe';
import { SortByPipe } from './sortBy.pipe';
import { StrPipe } from './str.pipe';
import { StringifyPipe } from './stringify.pipe';
import { TimeAgoPipe } from './time-ago.pipe';
import { TrustHtmlPipe } from './trusthtml.pipe';





@NgModule({
  declarations: [

  ],
  imports: [
    ACTransPipe, 
    CBTransPipe,
    MessageTransPipe,
    StrPipe, 
    StringifyPipe,
    IntPipe, 
    TrustHtmlPipe, 
    FilterPipe,

    NfPipe, 
    NfiPipe, 
    SortByPipe, 
    JoinPipe,
    TelephonePipe,
    TimeAgoPipe,
  ],
  exports: [
    ACTransPipe, 
    CBTransPipe,
    MessageTransPipe,
    StrPipe, 
    StringifyPipe,
    IntPipe, 
    TrustHtmlPipe, 
    FilterPipe,
    NfPipe, 
    NfiPipe, 
    SortByPipe,
    JoinPipe,
    TelephonePipe,
    TimeAgoPipe,
  ]
})
export class BtPipesModule {

}
